export default "__VITE_ASSET__dc2ea20b__"